import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicChartComponent } from './public-chart/public-chart.component';

import { ToolboxModule } from '../shared/toolbox/toolbox.module';
import { ChartsModule } from '../shared/toolbox/charts/charts.module';
import { ChartWrapperComponent } from '../shared/toolbox/charts/chart-wrapper/chart-wrapper.component';
import {ListsModule} from "../lists/lists.module";



@NgModule({
  declarations: [
    PublicChartComponent
  ],
    imports: [
        CommonModule,
        ToolboxModule,
        ChartsModule,
        ChartWrapperComponent,
        ListsModule,
    ],
  exports: [PublicChartComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PublicChartModule { }
